<template>
    <div>
        <form v-on:submit.prevent="$emit('submit', 'weddings', form)">
            <div class="contact-form-section">
                <div class="row">
                    <div class="col-md-4">
                        <span class="contact-form-section__label">Your Information</span>
                    </div>
                    <div class="col-md-8">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="">Your Name</label>
                                    <input type="text" v-model="form.fromName" class="form-control">
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="">Email Address</label>
                                    <input type="text" v-model="form.fromEmail" class="form-control">
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="">Telephone Number</label>
                                    <input type="text" v-model="form.message.telephone" class="form-control">
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="">Subject</label>
                                    <select name="" id="" v-model="form.message.subject" class="form-control">
                                        <option value="?">Please select one</option>
                                        <option value="Firewood">Firewood</option>
                                        <option value="Dexter Cattle">Dexter Cattle</option>
                                        <option value="Filming">Filming</option>
                                        <option value="Other">Other</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="contact-form-section">
                <div class="row">
                    <div class="col-md-4">
                        <span class="contact-form-section__label">Additional Information</span>
                    </div>
                    <div class="col-md-8">
                        <div class="form-group">
                            <label for="">Your Enquiry</label>
                            <textarea type="text" v-model="form.message['Enquiry']" class="form-control" rows="10"></textarea>
                        </div>
                    </div>
                </div>
            </div>

            <div class="contact-form-section">
                <div class="row">
                    <div class="col-md-4">
                        <span class="contact-form-section__label">Newsletter</span>
                    </div>
                    <div class="col-md-8">
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" v-model="form.newsletterSignup" value="" id="newsletterSignUp">
                            <label class="form-check-label" for="newsletterSignUp">
                                Keep up with our exciting upcoming events and what's happening at Finnebrogue Woods, including Fodder & Magnakata?
                            </label>
                        </div>
                    </div>
                </div>
            </div>
            <div class="contact-form-actions">
                <button class="button button--primary">Send</button>
            </div>
        </form>
    </div>
</template>

<script>
    export default {
        props: ['form']
    }
</script>